import b from 'b_';
import { Button, Link, SimpleText, Text } from 'platform-components';
import { getIsParent } from 'platform-components/src/components/user/selectors';
import { withRouterPath, InjectedProps as WithRouterPathHocProps } from 'platform-components/hocs';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ym from 'react-yandex-metrika';

// @ts-ignore
import { IconArrowLeft } from 'common.components/icon2';
import { BaseStudent } from 'common.components/typings';

import { StudentsPrintInvitationCard } from './__invitation-card/students-print__invitation-card';

import './students-print.scss';
import './students-print.print.scss';

interface HOCProps extends WithRouterPathHocProps {}

interface OwnProps {
    route?: {
        printAll?: boolean;
    };
    schoolCode?: string | null;
    shouldShowParentInvitation: boolean;
    shouldUsePassportAccounts?: boolean;
    students: Array<BaseStudent> | null;
}

interface Props extends HOCProps, OwnProps {}

const Component = (props: Props) => {
    const history = useHistory();
    const { getRouterPath, staticUrls } = props;

    const isParent = useSelector(getIsParent);

    const {
        match: {
            params: { studentId, childId },
        },
        route,
        schoolCode,
        shouldShowParentInvitation,
        students: ownStudents,
        shouldUsePassportAccounts,
    } = props;
    const printAll = route?.printAll;

    useEffect(() => {
        if (!isSSR) {
            window.scrollTo(0, 0);
        }
    }, []);

    const students = useMemo(() => {
        const id = isParent ? childId : studentId;

        if (id && !printAll) {
            const student = ownStudents?.find((s) => s.id === Number(id));
            return student ? [student] : [];
        }

        return ownStudents;
    }, [isParent, childId, studentId, ownStudents, printAll]);

    const print = useCallback(() => {
        const classLength = students && students.length;

        if (!window) {
            return;
        }

        ym('reachGoal', 'print_invitation', { studentsCount: classLength });

        window.print();
    }, [students]);

    const handleBackLink = () => {
        if (isParent) {
            history.push(getRouterPath(staticUrls.parentChildSettings, { childId }));
        } else {
            history.goBack();
        }
    };

    return (
        <section className="students-print">
            <div className="students-print__header">
                <div className="students-print__header-left-section">
                    <Link onClick={handleBackLink} pseudo>
                        <IconArrowLeft /> <Text id="class.backToClass" />
                    </Link>
                </div>
                <div className="students-print__header-center-section">
                    <Button className="students-print__print-button" onClick={print}>
                        <SimpleText id="class.print" />
                    </Button>
                </div>
                <div className={b('students-print', 'header-right-section')} />
            </div>
            <div className="students-print__cards">
                {students &&
                    students.map((student) => (
                        <StudentsPrintInvitationCard
                            key={student.id}
                            schoolCode={student.code || schoolCode}
                            shouldShowParentInvitation={shouldShowParentInvitation}
                            shouldUsePassportAccounts={shouldUsePassportAccounts}
                            student={student}
                        />
                    ))}
            </div>
        </section>
    );
};

export const StudentsPrint = withRouterPath(Component);
